<template>
    <FilterComponent :displayText="facet.title" class="range-facet">
        {{ facet.prompt }}
        <RangeSlider v-model="range" :min="facet.min" :max="facet.max" />
    </FilterComponent>
</template>

<script>
import { createRangeCriterion } from '@/utils/filters'

import FilterComponent from '../FilterComponent.vue'
import RangeSlider from '@/components/inputs/range-slider.vue'

export default {
    components: {
        FilterComponent,
        RangeSlider,
    },
    props: {
        facet: {
            type: Object,
            required: true,
        },
        criteria: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        current() {
            return this.criteria.find(c => c.name === this.facet.name)
        },
        range: {
            get() {
                return [this.min, this.max]
            },
            set(value) {
                this.update(value[0], value[1])
            },
        },
        min() {
            return this.current?.min || this.facet.min
        },
        max() {
            return this.current?.max || this.facet.max
        },
    },
    methods: {
        update(min, max) {
            let criteria = this.criteria.slice()
            let index = criteria.findIndex(c => c.name === this.facet.name)

            let target = createRangeCriterion(this.facet.name, this.facet.title, 'range', min, max)

            if (index < 0) {
                criteria.push(target)
            } else {
                criteria[index] = target
            }

            this.$emit('update:criteria', criteria)
        },
    },
}
</script>
<style>
.range-facet .range-slider {
    margin-top: 16px;
}
</style>
